var $2750f213b32ef8a6$exports = {};
$2750f213b32ef8a6$exports = {
    "colorFormat": `Color format`,
    "hex": `Hex`,
    "rgb": `RGB`,
    "hsl": `HSL`,
    "hsb": `HSB`
};


export {$2750f213b32ef8a6$exports as default};
//# sourceMappingURL=en-US.mjs.map
